<template>
  <div :componentid="id">
    <input class="form-control" :value="v" @input="update"/>
  </div>
</template>

<script>
import $ from 'jquery';
import jquery from 'jquery';
import jQuery from 'jquery';
import autocomplete from 'jquery-ui';

export default {
  name: "suggest",
  props:['value','list'],
  data(){
    return {
      v:this.value,
      id: null
    };
  },
  methods:{
    update(){
      this.$emit("input",this.v);
    }
  },
  mounted(){
    this.id=this._uid;
    setTimeout(()=>{
      console.log($("div[componentid=" + this.id + "]"));
      $("div[componentid=" + this.id + "] input").autocomplete({
        source: this.list
      });
    },2000);
  }
}
</script>

<style scoped>

</style>